import * as Y from 'yjs';
import JSZip from 'jszip';
import {readLegacySession} from '../../infrastructure/sync/readLegacySession';

export async function createLegacyMigrationArchive(doc, {localOnly = false} = {}) {
  const songs = new JSZip();
  const paths = [...doc.getMap('files').keys()].sort();
  if (!paths.length) throw new Error('Nie znaleziono zapisanych plików. Nie pobrano pustej kopii.');
  for (const path of paths) {
    if (typeof path !== 'string' || !path || path.startsWith('/') || path.includes('\\') ||
      path.split('/').some(part => !part || part === '.' || part === '..')) {
      throw new Error('Nieprawidłowa ścieżka w starej sesji.');
    }
    // An untouched empty Y.Text has no entry in a transmitted Yjs update.
    songs.file(path, doc.getText(`content:${path}`).toString());
  }
  const zip = new JSZip();
  // Yjs updates do not encode root type constructors. Materialize the known
  // legacy map roots before producing the human-readable recovery copy.
  for (const key of doc.share.keys()) {
    if (key.startsWith('content:')) doc.getText(key);
    else doc.getMap(key);
  }
  zip.file('spiewniki.zip', await songs.generateAsync({type: 'uint8array'}));
  zip.file('legacy-state.yjs', Y.encodeStateAsUpdate(doc));
  zip.file('legacy-data.json', JSON.stringify(doc.toJSON(), null, 2));
  zip.file('INSTRUKCJA.txt', `Migracja prywatnej sesji Chwały do Hosanny

Źródło: ${localOnly ? 'wyłącznie lokalna kopia z tej przeglądarki — może być niepełna' : 'stary serwer oraz lokalne zmiany z tej przeglądarki'}.
Liczba plików: ${paths.length}.

1. Rozpakuj ten ZIP i zachowaj pełną kopię w bezpiecznym miejscu.
2. Otwórz https://hosanna.panu.pl i zaloguj się. Utwórz osobny pokój dla tej sesji.
3. Przeciągnij spiewniki.zip do drzewa plików tego pokoju. Import przez przeciąganie dodaje pliki; import całego workspace zastępuje jego zawartość.
4. Sprawdź pliki i poczekaj na synchronizację. Przyznaj pozostałym osobom dostęp do tego samego pokoju Hosanny i przekaż im jego adres.

Stary login, hasło i ID sesji nie nadają dostępu do Hosanny.
Ulubione, historia, metadane i dawne backupy są zachowane w legacy-data.json oraz pełnym stanie legacy-state.yjs, lecz nie są automatycznie importowane do funkcji Hosanny.
Preferencje urządzenia i dane innych domen/przeglądarek nie są częścią tego eksportu.
Archiwum zawiera prywatne dane sesji. Nie publikuj go.
`);
  return {blob: await zip.generateAsync({type: 'blob'}), fileCount: paths.length,
    fileName: `Chwala-migracja${localOnly ? '-lokalna' : ''}-${new Date().toISOString().replace(/[:.]/g, '-')}.zip`};
}

export async function exportLegacySession(sessionId, options) {
  const doc = await readLegacySession(sessionId, options);
  try {return await createLegacyMigrationArchive(doc, options);}
  finally {doc.destroy();}
}
